import { render, staticRenderFns } from "./VariantSelectionForm.vue?vue&type=template&id=179deba2&"
import script from "./VariantSelectionForm.vue?vue&type=script&lang=js&"
export * from "./VariantSelectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports